var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"text-danger text-sm"},[_vm._v(_vm._s(_vm.$validators.email.msg))])}
var staticRenderFns = []

export { render, staticRenderFns }